import { render, staticRenderFns } from "./AddCategoryPage.vue?vue&type=template&id=0ea7a368&"
import script from "./AddCategoryPage.vue?vue&type=script&lang=js&"
export * from "./AddCategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./AddCategoryPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports